module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-2nd@3x-cfc107c1c6fc1382f06c1490ae4fc56a.png";